import styled from 'styled-components';
import { sharedStyles } from './sharedStyles';
export var AdIcon = styled.span.withConfig({
  displayName: "AdIcon",
  componentId: "sc-htgzso-0"
})(["display:block;", ";border-radius:", "px;box-shadow:", ";"], sharedStyles, function (_ref) {
  var small = _ref.small;
  return small ? 3 : 4;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.boxShadow;
});